module.exports = __webpack_public_path__ + "static/media/HA goal.4d59736a.png";